import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {ConfirmationDialogService} from '@services/confirmation-dialog.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-last-submitted-row-modal',
    templateUrl: './last-submitted-row-modal.component.html',
    styleUrls: ['./last-submitted-row-modal.component.scss'],
    standalone: false
})
export class LastSubmittedRowModalComponent {

  @Input()
  lastRow: Map<string, any> = new Map<string, any>();

  constructor(private activeModal: NgbActiveModal,
              private confirmationDialogService: ConfirmationDialogService,
              private translateService: TranslateService) {
  }

  get mapHasValues(): boolean {
    return this.lastRow.size > 0;
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onDeleteThisRow() {
    const submitTitle = this.translateService.instant('Delete row');
    const submitBody = this.translateService.instant('Do you really want to delete the last submitted row?');
    const submitOk = this.translateService.instant('Delete');
    this.confirmationDialogService.handleConfirmationDialog(submitTitle, submitBody, '', submitOk).subscribe(userConfirmed => {
      if (!userConfirmed) {
        return;
      }
      this.activeModal.close(this.lastRow);
    }, (error) => {
      console.log(error);
    });
  }

  inMilliseconds(timeStampInSeconds: number): number {
    return timeStampInSeconds * 1000;
  }
}